const checkFeature = (feature: string, organizationFeatures: string[]) => organizationFeatures.includes(feature);

export default checkFeature;
